import { StealDealWidgetRenderingDetails } from "@swiggy-private/cart-types";
import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { VALID_RENDERING_DETAILS_TYPE } from "@swiggy-private/cart-ui";
import { isEmpty } from "@swiggy-private/js-utils";

/**
 * Extracts steal deal widget data from cart response rendering details
 */
export const getStealDealWidgetData = (cartResponse: ReviewedCart | null): StealDealWidgetRenderingDetails | null => {
    if (isEmpty(cartResponse?.data?.rendering_details)) {
        return null;
    }

    const stealDealWidget = cartResponse?.data?.rendering_details?.find(
        (item) => item.type?.toLowerCase() === VALID_RENDERING_DETAILS_TYPE.STEAL_DEAL_WIDGET.toLowerCase(),
    );

    return (stealDealWidget as StealDealWidgetRenderingDetails) || null;
};

/**
 * Checks if steal deal widget should be displayed
 */
export const shouldShowStealDealWidget = (cartResponse: ReviewedCart | null): boolean => {
    const stealDealWidget = getStealDealWidgetData(cartResponse);

    if (isEmpty(stealDealWidget)) {
        return false;
    }

    const { meta } = stealDealWidget;
    return !isEmpty(meta?.items) && meta?.items?.length > 0;
};
